import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TooltipTypography } from '~/components/TooltipTypography/TooltipTypography';

export type TooltipCellValue = Union.Nullable<string | number>;

interface TooltipCellProps<R extends GridValidRowModel = any> {
  value: TooltipCellValue;
  row: R;
}

export const TooltipCell = ({ value }: TooltipCellProps) => {
  return (
    <>
      {value ? (
        <TooltipTypography title={value}>
          <span>{value}</span>
        </TooltipTypography>
      ) : (
        NULLISH_CELL_VALUE
      )}
    </>
  );
};
